import React from 'react';
import PropTypes from 'prop-types';

import { Marker, MarkerClusterer } from '@react-google-maps/api';

import ClusterFree from 'assets/images/ab-mapClusterGrey.png';
import MarkerFree from 'assets/images/ab-mapGrey.png';

const GetMapMarkers = ({ togglePopup, result }) => {
  const { data } = result || {};

  const clusterFree = {
    styles: [
      {
        url: ClusterFree,
        width: 35,
        height: 51,
        textColor: 'white',
        textSize: 14,
        fontFamily: 'Source Sans Pro',
      },
    ],
    clusterClass: 'clusterIcon',
  };

  if (data) {
    return (
      <MarkerClusterer minimumClusterSize={1} gridSize={100} options={clusterFree}>
        {(clusterer) =>
          (data.product || []).map((product) => {
            let { location } = product.postalAddresses[0];
            if (location) {
              location = location.replace('(', '').replace(')', '').split(',');
              const lat = location[0];
              const lng = location[1];
              return (
                <Marker
                  key={product.id}
                  position={{
                    lat: Number(lat),
                    lng: Number(lng),
                  }}
                  icon={MarkerFree}
                  onClick={() => togglePopup(product)}
                  clusterer={clusterer}
                />
              );
            }
            return null;
          })
        }
      </MarkerClusterer>
    );
  }
  return null;
};

export default GetMapMarkers;

GetMapMarkers.propTypes = {
  result: PropTypes.shape({
    data: PropTypes.shape(),
    loading: PropTypes.bool,
  }),
  togglePopup: PropTypes.func.isRequired,
};

GetMapMarkers.defaultProps = {
  result: {
    data: {},
    loading: true,
  },
};
